import faPlusCircle from "../../../../assets/images/fa-plus.svg";
import faSearchPlus from "../../../../assets/images/fa-search-plus.svg";
import faReload from "../../../../assets/images/fa-reload.svg";
import faEdit from "../../../../assets/images/fa-edit.svg";
import faUpload from "../../../../assets/images/fa-upload.svg";

import messages from "../messages";

export const icons = [
    {
        icon: faPlusCircle,
        ...messages.icons.create
    },
    {
        icon: faSearchPlus,
        ...messages.icons.inquiry
    },
    {
        icon: faReload,
        ...messages.icons.cancel
    },
    {
        icon: faEdit,
        ...messages.icons.update
    },
    {
        icon: faUpload,
        ...messages.icons.upload
    },
];